import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  IconButton,
  CircularProgress,
  Modal,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { CustomTextField } from "components";
import { UserService } from "services/UserService";
import { useAuth } from "context/authContext";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { Timestamp } from "firebase/firestore";

const LicenseUploaded = ({
  licenseData,
  setLicenseData,
  onChange = () => { },
  setShowIcons,
}: any) => {
  const { currentUser } = useAuth();

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState("");
  const [filePreview, setFilePreview] = useState<string | null>(
    licenseData.licenseImageUrl || null
  );
  const [formValues, setFormValues] = useState(licenseData);
  const [isLoading, setLoading] = useState(false);
  const [expirationDate, setExpirationDate] = useState<Dayjs | null>(
    licenseData?.licenseExpiration
      ? dayjs(licenseData?.licenseExpiration)
      : null
  );
  const [triggerRender, setTriggerRender] = useState(false);


  // useEffect(() => {
  //   // setLicenseData((prevData: any) => ({
  //   //   ...prevData,
  //   //   licenseImageUrl: formValues.licenseImageUrl,
  //   //   licenseExpiration: formValues.licenseExpiration,
  //   //   licenseNumber: formValues.licenseNumber,
  //   //   stateofLicensure: formValues.stateofLicensure,
  //   //   typeOfLicense: formValues.typeOfLicense,
  //   // }));

  //   setLicenseData((prevData: any) => ({
  //     ...prevData,
  //     licenseImageUrl: licenseData.licenseImageUrl,
  //     licenseExpiration: licenseData.licenseExpiration,
  //     licenseNumber: licenseData.licenseNumber,
  //     stateofLicensure: licenseData.stateofLicensure,
  //     typeOfLicense: licenseData.typeOfLicense,
  //   }));

  //   setTriggerRender((prev) => !prev); // Force re-render

  //   setShowIcons((prevState: any) => ({
  //     ...prevState,
  //     license: (
  //       licenseData.licenseImageUrl &&
  //       licenseData.licenseExpiration &&
  //       licenseData.typeOfLicense &&
  //       licenseData.licenseNumber &&
  //       licenseData.stateofLicensure &&
  //       filePreview // Ensure filePreview is set correctly
  //     ),
  //   }));


  //   console.log("licenseData:", licenseData);
  //   console.log("formValues:", formValues);


  // }, [formValues, filePreview]); // Added filePreview as dependency


  /** ✅ Ensures state updates correctly when switching tabs */
  useEffect(() => {
    setFormValues({ ...licenseData });
    setFilePreview(licenseData.licenseImageUrl || null);
  }, [licenseData]);

  /** ✅ Correctly updates licenseData without stale closures */
  // useEffect(() => {
  //   setLicenseData((prevData: any) => ({
  //     ...prevData,
  //     ...formValues,
  //   }));
  // ✅ Correctly updates licenseData without causing infinite re-renders
  useEffect(() => {
    if (JSON.stringify(licenseData) !== JSON.stringify(formValues)) {
      setLicenseData((prevData: any) => ({
        ...prevData,
        ...formValues,
      }));
    }

    setShowIcons((prevState: any) => ({
      ...prevState,
      license: !!(
        formValues.licenseImageUrl &&
        formValues.licenseExpiration &&
        formValues.typeOfLicense &&
        formValues.licenseNumber &&
        formValues.stateofLicensure &&
        filePreview
      ),
    }));
  }, [formValues, filePreview, setLicenseData, setShowIcons]);

  // Update parent state when input fields change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLicenseData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUploadLicense = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setLoading(true);
  //   const file = e.target.files?.[0];
  //   if (file) {
  //     setFileName(file.name);

  //     try {
  //       const downloadURL = await UserService.uploadProfilePicture(
  //         currentUser.uid,
  //         file
  //       );
  //       setFilePreview(downloadURL);

  //       // Update the formValues to include licenseImageUrl
  //       setFormValues((prevValues: any) => ({
  //         ...prevValues,
  //         licenseImageUrl: downloadURL,
  //       }));
  //     } catch (error) {
  //       console.error("Error uploading profile picture:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   } else {
  //     setLoading(false);
  //   }
  // };

  // Handle expiration date change
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);

      try {
        const downloadURL = await UserService.uploadProfilePicture(
          currentUser.uid,
          file
        );

        setFilePreview(downloadURL); // Ensure file preview updates
        setFormValues((prevValues: any) => ({
          ...prevValues,
          licenseImageUrl: downloadURL, // Store the uploaded file URL
        }));

        // Update the main license data
        setLicenseData((prevData: any) => ({
          ...prevData,
          licenseImageUrl: downloadURL,
        }));

        // Ensure icons visibility updates
        setShowIcons((prevState: any) => ({
          ...prevState,
          license: true,
        }));
      } catch (error) {
        console.error("Error uploading profile picture:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const handleExpirationDateChange = (newDate: Dayjs | null) => {
    setExpirationDate(newDate);
    setLicenseData((prevData: any) => ({
      ...prevData,
      // licenseExpiration: newDate ? newDate.toISOString() : "",
      licenseExpiration: newDate ? Timestamp.fromDate(newDate.toDate()) : null,
    }));
  };

  return (
    <>
      {/* <DocumentModal
        filePreview={"https://firebasestorage.googleapis.com/v0/b/affekti---project.appspot.com/o/files%2Ffd4cc0bd-4b5a-41f4-8f7d-81c3fe4ab63b?alt=media&token=8790c05d-39ac-4c44-8101-3bac014f8ec3"}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      /> */}
      <Grid
        display={"flex"}
        gap={5}
        flexDirection={"column"}
        p={{ xs: 2, md: 5 }}
        mt={{ xs: 3, md: 0 }}
      >
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: "18px",
              color: "#000000",
              marginBottom: 2,
            }}
          >
            Please upload your license
          </Typography>
          <Box sx={styleSheet.constainer}>
            {!filePreview ? (
              <Box sx={styleSheet.downContainer}>
                <CloudUploadIcon sx={{ fontSize: 40, color: "#666" }} />
                <Typography variant="body1" sx={{ marginTop: 1 }}>
                  Drag & Drop or choose file to upload
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#666", marginTop: 1 }}
                >
                  Select an Image
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: 2,
                    backgroundColor: "#233F91",
                    color: "#fff",
                    borderRadius: "15px",
                    width: "215px",
                    height: "57px",
                    mt: 2,
                  }}
                  onClick={handleUploadLicense}
                >
                  {isLoading ? <CircularProgress size={24} /> : "Browse File"}
                </Button>
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </Box>
            ) : (
              <Grid display={"flex"} alignItems={"center"} flex={1}>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "599px",
                      height: "51px",
                      border: "2px dashed #ccc",
                      borderRadius: "9px",
                      display: "flex",
                      alignItems: "center",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Typography
                      ml={2}
                      fontSize={"18px"}
                      fontWeight={700}
                      color={"#595959"}
                    >
                      {filePreview}
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={() => {
                      setFilePreview(null);
                      setFormValues((prev: any) => ({
                        ...prev,
                        licenseImageUrl: "",
                      }));
                      setLicenseData((prevData: any) => ({
                        ...prevData,
                        licenseImageUrl: "",
                      }));
                    }}
                    sx={{ color: "#FF0000" }}
                  >
                    <img src="assets/icons/iconDelete.png" alt="delete" />
                  </IconButton>

                </Box>
              </Grid>
            )}
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          display={"flex"}
          gap={1}
          flexDirection={"column"}
        >
          <label htmlFor="licenseExpiration" style={styleSheet.labelText}>
            License Expiration
          </label>
          <Grid display={"flex"} gap={2} alignItems={"center"} flex={1}>
            <Box sx={{ flexGrow: 1 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["day", "month", "year"]}
                  value={expirationDate}
                  onChange={handleExpirationDateChange}
                  format="MM/DD/YYYY"
                  // disableFuture={false}
                  disablePast
                  slotProps={{
                    textField: {
                      inputProps: { readOnly: true }, // ⛔ Prevent manual typing
                    },
                  }}
                  sx={styleSheet.datePicker}
                />
              </LocalizationProvider>
            </Box>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          display={"flex"}
          gap={1}
          flexDirection={"column"}
        >
          <label htmlFor="typeOfLicense" style={styleSheet.labelText}>
            Type of License
          </label>
          <Grid display={"flex"} gap={2} alignItems={"center"} flex={1}>
            <Box sx={{ flexGrow: 1 }}>
              <CustomTextField
                name="typeOfLicense"
                sx={styleSheet.customField}
                value={licenseData.typeOfLicense}
                onChange={handleChange}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          display={"flex"}
          gap={1}
          flexDirection={"column"}
        >
          <label htmlFor="licenseNumber" style={styleSheet.labelText}>
            License Number
          </label>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name="licenseNumber"
              type="number"
              sx={styleSheet.customField}
              value={licenseData.licenseNumber}
              onChange={handleChange}
            />
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          display={"flex"}
          gap={1}
          flexDirection={"column"}
        >
          <label htmlFor="stateofLicensure" style={styleSheet.labelText}>
            State of Licensure
          </label>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name="stateofLicensure"
              sx={styleSheet.customField}
              value={licenseData.stateofLicensure}
              onChange={handleChange}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default LicenseUploaded;

const styleSheet = {
  labelText: {
    fontWeight: 400,
    fontSize: "17px",
    color: "#000000",
  },
  customField: {
    width: "100%",
    maxWidth: "599px",
  },
  downContainer: {
    border: "2px dashed #ccc",
    width: { xs: "295px", md: "563px" },
    height: "276px",
    borderRadius: "8px",
    padding: "16px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    backgroundColor: "#f9f9f9",
  },
  constainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "654px",
  },
  datePicker: {
    width: { xs: "100%", md: "599px" },
    "& .MuiInputBase-root": {
      backgroundColor: "transparent",
      borderRadius: "9px",
      height: "50px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9", // Regular border color
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9",
      boxShadow: "0px 0px 0px 4px #C9C9C9",
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9", // Override the red border color when in error state
    },
    "& .MuiSvgIcon-root": {
      color: "#707070",
    },
  },
};
